import React from 'react';
import './FloatingBackground.css';

export function FloatingBackground() {
  return (
    <div className="floating-background" aria-hidden="true">
      <span className="floating-square square-1"></span>
      <span className="floating-square square-2"></span>
      <span className="floating-square square-3"></span>
      <span className="floating-square square-4"></span>
      <span className="floating-square square-5"></span>
    </div>
  );
}
